import { Component, OnInit, Input } from '@angular/core';
import { Location } from '@angular/common';
import { UtilityServiceService } from 'projects/services/src/app/API/utility-service.service';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import { ShareDataService } from 'projects/shared/src/app/shared/share-data.service';
import { ActivatedRoute } from '@angular/router';
declare const swal: any;
declare var toastr: any;
@Component({
  selector: 'cpac-form',
  templateUrl: './cpac-form.component.html',
  styleUrls: ['./cpac-form.component.css']
})
export class CpacFormComponent implements OnInit {
  @Input() batchDetails: any;
  @Input() candidateId: any;

  feedbackForm: FormGroup
  candidateAttendaceForm: FormGroup
  qualityRatingForm: FormGroup
  questions: any = [];
  hideShowQOne: boolean
  hideShowQTwo: boolean
  specialQuestion: any;
  loggedInUserName: any;
  isUpdate: boolean;
  role: any;
  feedbackType: any;
  showLabel: boolean;
  hideForm: boolean;
  isCandidateSubmitted: boolean;
  constructor(
    private location: Location,
    private utilityService: UtilityServiceService,
    private currentUserService: CurrentUserService,
    private fb: FormBuilder,
    private sharedService: ShareDataService,
    private router: ActivatedRoute
  ) {
    this.sharedService.getFeedbackType().subscribe(type => {
      this.feedbackType = type;
    })
    this.sharedService.getFeedbackHistory().subscribe(id => {
      this.historyId = id;
    })
    this.candidateAttendaceForm = this.fb.group({
      feedbacks: fb.array([]),
      trainer: [false],
      equipmentForTraining: [false],
      qualityOfTrainingDelivery: [false],
      qualityOfCourseMaterials: [false],
      qualityOfAssessment: [false],
      supportFromTPonPlacement: [false],
      others: [false],
      otherAnswer: ['']

    });
    this.qualityRatingForm = this.fb.group({
			rating: fb.array([])
    });

    this.currentUserService.getCurrentUser().subscribe(res => {
      this.loggedInUserName = res && res.userName;
      this.role = res && res.role;
    })
  }

  get candidate(): FormArray {
		return this.candidateAttendaceForm.get('feedbacks') as FormArray;
  }
  get ratings(): FormArray {
		return this.qualityRatingForm.get('rating') as FormArray;
  }

  createTrainingDetails(data) {
		return this.fb.group({
      feedback: this.fb.group({
        id: [data.id],
				question: [data.questionString],
        choice: [null, [Validators.required]],
        others: [''],
			})
		});
  }

  update(data) {
    console.log(data);

  }
  createQualityRating(data) {
		return this.fb.group({
			ratingArray: this.fb.group({
        question: [data.questionString],
        choice: [null, [Validators.required]],
			})
		});
  }


  ngOnInit() {
    this.feedbackForm = this.fb.group({
      feedback: this.fb.array([])
    })
    console.log(this.batchDetails)
    if (this.role === 'Continuous Monitoring' || this.role === 'Fee Based DA') {
      this.router.params.subscribe(params => {
        this.candidateId = params.canId;
        this.getQuestionsForCandidate();
      });      // this.loggedInUserName = this.batchDetails && this.batchDetails.candidates && this.batchDetails.candidates.candidateId
    } else {
      this.getQuestionsForCandidate();
    }

  }

  checkIfOthers() {
    if (this.candidateAttendaceForm.get('others').value) {
      this.candidateAttendaceForm.get('otherAnswer').reset()
      this.candidateAttendaceForm.get('otherAnswer').setValidators([Validators.required])
      this.candidateAttendaceForm.get('otherAnswer').updateValueAndValidity();
    } else {
      this.candidateAttendaceForm.get('otherAnswer').reset()
      this.candidateAttendaceForm.get('otherAnswer').setValidators([])
      this.candidateAttendaceForm.get('otherAnswer').updateValueAndValidity();
    }
  }


  getFeedBackForm() {
    if (this.candidateAttendaceForm.get('feedbacks')
      && this.candidateAttendaceForm.get('feedbacks')['controls']
      && this.candidateAttendaceForm.get('feedbacks')['controls'][2]
    ) {
      this.candidateAttendaceForm.get('feedbacks')['controls'][2].get('feedback').get('choice').setValidators([])
      this.candidateAttendaceForm.get('feedbacks')['controls'][2].get('feedback').get('choice').updateValueAndValidity()
    }
    if (this.candidateAttendaceForm.get('feedbacks')
    && this.candidateAttendaceForm.get('feedbacks')['controls']
    && this.candidateAttendaceForm.get('feedbacks')['controls'][6]
  )  {
    this.candidateAttendaceForm.get('feedbacks')['controls'][6].get('feedback').get('choice').setValidators([])
    this.candidateAttendaceForm.get('feedbacks')['controls'][6].get('feedback').get('choice').updateValueAndValidity()
    }
    if (this.feedbackType === 'history') {
      if (this.role === 'Candidate') {
        this.utilityService.getFeedbackData(this.batchDetails.batchId, this.loggedInUserName, 'CPAC').subscribe(res => {
          const feedbackData = res && res.data && res.data.feedback || [];

          for (let index = 0; index < feedbackData.length; index++){
            if (feedbackData && feedbackData.length > 0) {
              this.isUpdate = true;
            } else {
              this.showLabel = true;
              this.hideForm = true;
            }

            if (feedbackData[index].question !== "How would you rate the quality of training?"
            ) {
              if (feedbackData[index].question !== "What could have made the training better?") {
                this.candidateAttendaceForm.get('feedbacks')['controls'][index].get('feedback').get('choice').patchValue(feedbackData[index].answer);
                this.candidateAttendaceForm.get('feedbacks')['controls'][index].get('feedback').get('others').patchValue(feedbackData[index].others);

              } else if (feedbackData[index].question === "What could have made the training better?") {
                const trainer = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.trainer || false;
                const equipmentForTraining = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.equipmentForTraining || false;
                const qualityOfTrainingDelivery = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.qualityOfTrainingDelivery || false;
                const qualityOfAssessment = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.qualityOfAssessment || false;
                const supportFromTPonPlacement = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.supportFromTPonPlacement || false;
                const qualityOfCourseMaterials = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.qualityOfCourseMaterials || false;
                const others = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.others || false;
                const otherAnswer = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.otherAnswer || false;


                this.candidateAttendaceForm.get('trainer').patchValue(trainer);
                this.candidateAttendaceForm.get('equipmentForTraining').patchValue(equipmentForTraining);
                this.candidateAttendaceForm.get('qualityOfTrainingDelivery').patchValue(qualityOfTrainingDelivery);
                this.candidateAttendaceForm.get('qualityOfAssessment').patchValue(qualityOfAssessment);
                this.candidateAttendaceForm.get('supportFromTPonPlacement').patchValue(supportFromTPonPlacement);
                this.candidateAttendaceForm.get('qualityOfCourseMaterials').patchValue(qualityOfCourseMaterials);
                this.candidateAttendaceForm.get('others').patchValue(others);
                this.candidateAttendaceForm.get('otherAnswer').patchValue(otherAnswer);
              }
            } else if (feedbackData[index].question === 'How would you rate the quality of training?') {
              const subAnswer = feedbackData[index].answer;
              if (subAnswer.length > 0) {
                for (let indexx = 0; indexx < subAnswer.length; indexx++) {
                    this.qualityRatingForm.get('rating')['controls'][indexx].get('ratingArray').get('choice').patchValue(subAnswer[indexx].answer);
                }
              }
            }

            if (this.candidateAttendaceForm.get('feedbacks')['controls'][3].get('feedback').getRawValue().choice === false) {
              this.candidateAttendaceForm.get('feedbacks')['controls'][6].get('feedback').get('choice').setValidators([])
              this.candidateAttendaceForm.get('feedbacks')['controls'][6].get('feedback').get('choice').updateValueAndValidity()

            }

            if (feedbackData[index].answer === null) {
              this.candidateAttendaceForm.get('trainer').disable()
              this.candidateAttendaceForm.get('equipmentForTraining').disable()
              this.candidateAttendaceForm.get('qualityOfTrainingDelivery').disable()
              this.candidateAttendaceForm.get('qualityOfAssessment').disable()
              this.candidateAttendaceForm.get('supportFromTPonPlacement').disable()
              this.candidateAttendaceForm.get('qualityOfCourseMaterials').disable()
              this.candidateAttendaceForm.get('others').disable()
              this.candidateAttendaceForm.get('otherAnswer').disable()
              this.candidateAttendaceForm.get('feedbacks')['controls'][index].get('feedback').get('choice').disable();
              this.candidateAttendaceForm.get('feedbacks')['controls'][index].get('feedback').get('choice').setValidators([]);
              this.candidateAttendaceForm.get('feedbacks')['controls'][index].get('feedback').get('choice').updateValueAndValidity()

            }

          //   if (feedbackData[index].question === 'Have you completed the assessment?') {
          //     if (feedbackData[index].answer) {
          //       this.candidateAttendaceForm.get('feedbacks')['controls'][index].get('feedback').get('choice').patchValue(true)
          //     } else
          //   }
          }

        })
      }
      else if (this.role === 'Training Partner') {
        this.utilityService.getFeedbackHistoryById(this.historyId).subscribe(res => {
          const feedbackData = res && res.data && res.data.d && res.data.d.feedback;
          if (feedbackData) {
            this.isUpdate = true;

          }
          for (let index = 0; index < feedbackData.length; index++){

            if (this.candidateAttendaceForm.get('feedbacks')['controls'][3].get('feedback').getRawValue().choice === false) {
              this.candidateAttendaceForm.get('feedbacks')['controls'][6].get('feedback').get('choice').setValidators([])
              this.candidateAttendaceForm.get('feedbacks')['controls'][6].get('feedback').get('choice').updateValueAndValidity()

            }
            if (feedbackData[index].answer === null) {
              this.candidateAttendaceForm.get('trainer').disable()
              this.candidateAttendaceForm.get('equipmentForTraining').disable()
              this.candidateAttendaceForm.get('qualityOfTrainingDelivery').disable()
              this.candidateAttendaceForm.get('qualityOfAssessment').disable()
              this.candidateAttendaceForm.get('supportFromTPonPlacement').disable()
              this.candidateAttendaceForm.get('qualityOfCourseMaterials').disable()
              this.candidateAttendaceForm.get('others').disable()
              this.candidateAttendaceForm.get('otherAnswer').disable()
              this.candidateAttendaceForm.get('feedbacks')['controls'][index].get('feedback').get('choice').disable();
              this.candidateAttendaceForm.get('feedbacks')['controls'][index].get('feedback').get('choice').setValidators([]);
              this.candidateAttendaceForm.get('feedbacks')['controls'][index].get('feedback').get('choice').updateValueAndValidity()

            }
            if (feedbackData[index].question !== "How would you rate the quality of training?"
            ) {
              if (feedbackData[index].question !== "What could have made the training better?") {
                this.candidateAttendaceForm.get('feedbacks')['controls'][index].get('feedback').get('choice').patchValue(feedbackData[index].answer);
                this.candidateAttendaceForm.get('feedbacks')['controls'][index].get('feedback').get('others').patchValue(feedbackData[index].others);
                this.candidateAttendaceForm.get('feedbacks')['controls'][index].get('feedback').get('choice').disable()
                this.candidateAttendaceForm.get('feedbacks')['controls'][index].get('feedback').get('others').disable()

              } else if (feedbackData[index].question === "What could have made the training better?") {
                const trainer = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.trainer || false;
                const equipmentForTraining = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.equipmentForTraining || false;
                const qualityOfTrainingDelivery = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.qualityOfTrainingDelivery || false;
                const qualityOfAssessment = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.qualityOfAssessment || false;
                const supportFromTPonPlacement = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.supportFromTPonPlacement || false;
                const qualityOfCourseMaterials = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.qualityOfCourseMaterials || false;
                const others = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.others || false;
                const otherAnswer = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.otherAnswer || false;


                this.candidateAttendaceForm.get('trainer').patchValue(trainer);
                this.candidateAttendaceForm.get('equipmentForTraining').patchValue(equipmentForTraining);
                this.candidateAttendaceForm.get('qualityOfTrainingDelivery').patchValue(qualityOfTrainingDelivery);
                this.candidateAttendaceForm.get('qualityOfAssessment').patchValue(qualityOfAssessment);
                this.candidateAttendaceForm.get('supportFromTPonPlacement').patchValue(supportFromTPonPlacement);
                this.candidateAttendaceForm.get('qualityOfCourseMaterials').patchValue(qualityOfCourseMaterials);
                this.candidateAttendaceForm.get('others').patchValue(others);
                this.candidateAttendaceForm.get('otherAnswer').patchValue(otherAnswer);

                this.candidateAttendaceForm.get('trainer').disable()
                this.candidateAttendaceForm.get('equipmentForTraining').disable()
                this.candidateAttendaceForm.get('qualityOfTrainingDelivery').disable()
                this.candidateAttendaceForm.get('qualityOfAssessment').disable()
                this.candidateAttendaceForm.get('supportFromTPonPlacement').disable()
                this.candidateAttendaceForm.get('qualityOfCourseMaterials').disable()
                this.candidateAttendaceForm.get('others').disable()
                this.candidateAttendaceForm.get('otherAnswer').disable()
              }
            } else if (feedbackData[index].question === 'How would you rate the quality of training?') {
              const subAnswer = feedbackData[index].answer;
              if (subAnswer.length > 0) {
                for (let indexx = 0; indexx < subAnswer.length; indexx++) {
                    this.qualityRatingForm.get('rating')['controls'][indexx].get('ratingArray').get('choice').patchValue(subAnswer[indexx].answer);
                    this.qualityRatingForm.get('rating')['controls'][indexx].get('ratingArray').disable()
                }
              }
            }
          }
        })
      }
    } else {
      if (this.role === 'Candidate') {
        this.utilityService.getFeedbackData(this.batchDetails.batchId, this.loggedInUserName, 'CPAC').subscribe(res => {
          const feedbackData = res && res.data && res.data.feedback || [];

          for (let index = 0; index < feedbackData.length; index++){
            if (feedbackData && feedbackData.length > 0) {
              this.isUpdate = true;
            } else {
              this.showLabel = true;
              this.hideForm = true;
            }

            if (feedbackData[index].question !== "How would you rate the quality of training?"
            ) {
              if (feedbackData[index].question !== "What could have made the training better?") {
                this.candidateAttendaceForm.get('feedbacks')['controls'][index].get('feedback').get('choice').patchValue(feedbackData[index].answer);
                this.candidateAttendaceForm.get('feedbacks')['controls'][index].get('feedback').get('others').patchValue(feedbackData[index].others);

              } else if (feedbackData[index].question === "What could have made the training better?") {
                const trainer = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.trainer || false;
                const equipmentForTraining = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.equipmentForTraining || false;
                const qualityOfTrainingDelivery = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.qualityOfTrainingDelivery || false;
                const qualityOfAssessment = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.qualityOfAssessment || false;
                const supportFromTPonPlacement = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.supportFromTPonPlacement || false;
                const qualityOfCourseMaterials = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.qualityOfCourseMaterials || false;
                const others = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.others || false;
                const otherAnswer = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.otherAnswer || false;


                this.candidateAttendaceForm.get('trainer').patchValue(trainer);
                this.candidateAttendaceForm.get('equipmentForTraining').patchValue(equipmentForTraining);
                this.candidateAttendaceForm.get('qualityOfTrainingDelivery').patchValue(qualityOfTrainingDelivery);
                this.candidateAttendaceForm.get('qualityOfAssessment').patchValue(qualityOfAssessment);
                this.candidateAttendaceForm.get('supportFromTPonPlacement').patchValue(supportFromTPonPlacement);
                this.candidateAttendaceForm.get('qualityOfCourseMaterials').patchValue(qualityOfCourseMaterials);
                this.candidateAttendaceForm.get('others').patchValue(others);
                this.candidateAttendaceForm.get('otherAnswer').patchValue(otherAnswer);
              }
            } else if (feedbackData[index].question === 'How would you rate the quality of training?') {
              const subAnswer = feedbackData[index].answer;
              if (subAnswer.length > 0) {
                for (let indexx = 0; indexx < subAnswer.length; indexx++) {
                    this.qualityRatingForm.get('rating')['controls'][indexx].get('ratingArray').get('choice').patchValue(subAnswer[indexx].answer);
                }
              }
            }

            if (this.candidateAttendaceForm.get('feedbacks')['controls'][3].get('feedback').getRawValue().choice === false) {
              this.candidateAttendaceForm.get('feedbacks')['controls'][6].get('feedback').get('choice').setValidators([])
              this.candidateAttendaceForm.get('feedbacks')['controls'][6].get('feedback').get('choice').updateValueAndValidity()

            }

            if (feedbackData[index].answer === null) {
              this.candidateAttendaceForm.get('trainer').disable()
              this.candidateAttendaceForm.get('equipmentForTraining').disable()
              this.candidateAttendaceForm.get('qualityOfTrainingDelivery').disable()
              this.candidateAttendaceForm.get('qualityOfAssessment').disable()
              this.candidateAttendaceForm.get('supportFromTPonPlacement').disable()
              this.candidateAttendaceForm.get('qualityOfCourseMaterials').disable()
              this.candidateAttendaceForm.get('others').disable()
              this.candidateAttendaceForm.get('otherAnswer').disable()
              this.candidateAttendaceForm.get('feedbacks')['controls'][index].get('feedback').get('choice').disable();
              this.candidateAttendaceForm.get('feedbacks')['controls'][index].get('feedback').get('choice').setValidators([]);
              this.candidateAttendaceForm.get('feedbacks')['controls'][index].get('feedback').get('choice').updateValueAndValidity()

            }

          //   if (feedbackData[index].question === 'Have you completed the assessment?') {
          //     if (feedbackData[index].answer) {
          //       this.candidateAttendaceForm.get('feedbacks')['controls'][index].get('feedback').get('choice').patchValue(true)
          //     } else
          //   }
          }

        })
      } else if (this.role === 'Training Partner' || this.role === 'Continuous Monitoring' ||  this.role === 'Fee Based DA') {
        this.utilityService.getFeedbackData(this.batchDetails.batchId, this.candidateId, 'CPAC').subscribe(res => {
          const feedbackData = res && res.data && res.data.feedback;
          if (feedbackData) {
            this.isUpdate = true;
          } else {
            this.showLabel = true;
            this.hideForm = true;
          }
          for (let index = 0; index < feedbackData.length; index++){
            if (feedbackData[index].question !== "How would you rate the quality of training?"
            ) {
              if (feedbackData[index].question !== "What could have made the training better?") {
                this.candidateAttendaceForm.get('feedbacks')['controls'][index].get('feedback').get('choice').patchValue(feedbackData[index].answer);
                this.candidateAttendaceForm.get('feedbacks')['controls'][index].get('feedback').get('others').patchValue(feedbackData[index].others);
                this.candidateAttendaceForm.get('feedbacks')['controls'][index].get('feedback').get('choice').disable()
                this.candidateAttendaceForm.get('feedbacks')['controls'][index].get('feedback').get('others').disable()

              } else if (feedbackData[index].question === "What could have made the training better?") {
                const trainer = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.trainer || false;
                const equipmentForTraining = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.equipmentForTraining || false;
                const qualityOfTrainingDelivery = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.qualityOfTrainingDelivery || false;
                const qualityOfAssessment = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.qualityOfAssessment || false;
                const supportFromTPonPlacement = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.supportFromTPonPlacement || false;
                const qualityOfCourseMaterials = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.qualityOfCourseMaterials || false;
                const others = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.others || false;
                const otherAnswer = feedbackData[index] && feedbackData[index].answer && feedbackData[index].answer.otherAnswer || false;


                this.candidateAttendaceForm.get('trainer').patchValue(trainer);
                this.candidateAttendaceForm.get('equipmentForTraining').patchValue(equipmentForTraining);
                this.candidateAttendaceForm.get('qualityOfTrainingDelivery').patchValue(qualityOfTrainingDelivery);
                this.candidateAttendaceForm.get('qualityOfAssessment').patchValue(qualityOfAssessment);
                this.candidateAttendaceForm.get('supportFromTPonPlacement').patchValue(supportFromTPonPlacement);
                this.candidateAttendaceForm.get('qualityOfCourseMaterials').patchValue(qualityOfCourseMaterials);
                this.candidateAttendaceForm.get('others').patchValue(others);
                this.candidateAttendaceForm.get('otherAnswer').patchValue(otherAnswer);

                this.candidateAttendaceForm.get('trainer').disable()
                this.candidateAttendaceForm.get('equipmentForTraining').disable()
                this.candidateAttendaceForm.get('qualityOfTrainingDelivery').disable()
                this.candidateAttendaceForm.get('qualityOfAssessment').disable()
                this.candidateAttendaceForm.get('supportFromTPonPlacement').disable()
                this.candidateAttendaceForm.get('qualityOfCourseMaterials').disable()
                this.candidateAttendaceForm.get('others').disable()
                this.candidateAttendaceForm.get('otherAnswer').disable()
              }
            } else if (feedbackData[index].question === 'How would you rate the quality of training?') {
              const subAnswer = feedbackData[index].answer;
              if (subAnswer.length > 0) {
                for (let indexx = 0; indexx < subAnswer.length; indexx++) {
                    this.qualityRatingForm.get('rating')['controls'][indexx].get('ratingArray').get('choice').patchValue(subAnswer[indexx].answer);
                    this.qualityRatingForm.get('rating')['controls'][indexx].get('ratingArray').disable()
                }
              }
            }
          }
        })
      }
    }

  }
  historyId(historyId: any) {
    throw new Error("Method not implemented.");
  }






  updateFeedBack() {

  }

  createFeedbackForm(data): FormGroup {
    return this.fb.group({
      questions: data.questionString,
      answer: [false],

    })
  }

  mapPayload() {
    const elements = (this.candidateAttendaceForm.getRawValue().feedbacks) || [];
    const mapElements = elements.map(element => ({
      question: element && element.feedback && element.feedback.question,
      answer: element && element.feedback && element.feedback.choice,
      others: element && element.feedback && element.feedback.others
    }))
    const qElements = (this.qualityRatingForm.getRawValue().rating) || []
    const qMapElements = qElements.map(qelement => ({
      subQuestion: qelement && qelement.ratingArray && qelement.ratingArray.question,
      answer: qelement && qelement.ratingArray && qelement.ratingArray.choice
    }))
    mapElements[2].answer = qMapElements;
    let trainingBetterObj = {
      others: this.candidateAttendaceForm.get('others').value,
      qualityOfAssessment: this.candidateAttendaceForm.get('qualityOfAssessment').value,
      qualityOfCourseMaterials: this.candidateAttendaceForm.get('qualityOfCourseMaterials').value,
      qualityOfTrainingDelivery: this.candidateAttendaceForm.get('qualityOfTrainingDelivery').value,
      supportFromTPonPlacement: this.candidateAttendaceForm.get('supportFromTPonPlacement').value,
      equipmentForTraining: this.candidateAttendaceForm.get('equipmentForTraining').value,
      trainer: this.candidateAttendaceForm.get('trainer').value,
      otherAnswer: this.candidateAttendaceForm.get('otherAnswer').value
    }
    mapElements[6].answer = trainingBetterObj
    const DATA = {
      tpName: this.batchDetails && this.batchDetails.tpName || '',
      tcName: this.batchDetails && this.batchDetails.tcName || '',
      tpId: this.batchDetails && this.batchDetails.tpId || '',
      tcId: this.batchDetails && this.batchDetails.tcId || '',
      qpCode: this.batchDetails && this.batchDetails.jobRoles && this.batchDetails.jobRoles[0] && this.batchDetails.jobRoles[0].qpCode || '',
      jobRoleDesc: this.batchDetails && this.batchDetails.jobRoles && this.batchDetails.jobRoles[0] && this.batchDetails.jobRoles[0].jobRoleDesc || '',
      jobName: this.batchDetails && this.batchDetails.jobRoles && this.batchDetails.jobRoles[0] && this.batchDetails.jobRoles[0].jobName || '',
      batchId: this.batchDetails.batchId,
      createdBy: this.loggedInUserName,
      type: 'CPAC',
      feedback: mapElements
    }
    return DATA;
  }


  getQuestionsForCandidate() {
    this.specialQuestion = [];
    this.utilityService.getMasterQuestion('CPAC').subscribe(res => {

      this.questions = res && res.data || [];
      console.log(this.questions)
      for (let index = 0; index < this.questions.length; index++) {
        if (this.questions[index].id === 'Q7') {
          this.specialQuestion = this.questions[index].questionString.split(",")
          this.questions[index].questionString = this.specialQuestion[0]
        }
        // formInstance.push(this.createFeedbackForm(this.questions[index]))
        this.candidate.push(this.createTrainingDetails(this.questions[index]));
        if (this.questions[index].id === "Q3") {
          for (let indexx = 0; indexx < this.questions[index].subQuestions.length; indexx++) {
            this.ratings.push(this.createQualityRating(this.questions[index].subQuestions[indexx]))
          }
        }
      }
      this.getFeedBackForm()
    })
    console.log('FORM', this.feedbackForm)
  }

  displayQuestion(qId,question) {
    if (qId === 'Q1') {
      const tpName = this.batchDetails && this.batchDetails.tpName || ''
      let replacedString = question.replace("[TP Name]", `"${ tpName }"`);
      return replacedString
    } else {
      return question
    }
  }

  sumitFeedback() {
    this.utilityService.isEnrollmentCompleted(this.batchDetails.batchId, this.loggedInUserName).subscribe(res => {
      if (res && res.data && res.data.completed) {
        const other = this.candidateAttendaceForm.get('others').value
        const qOA = this.candidateAttendaceForm.get('qualityOfAssessment').value
        const qoC = this.candidateAttendaceForm.get('qualityOfCourseMaterials').value
        const Qot = this.candidateAttendaceForm.get('qualityOfTrainingDelivery').value
        const SFP = this.candidateAttendaceForm.get('supportFromTPonPlacement').value
        const efT = this.candidateAttendaceForm.get('equipmentForTraining').value
        const tr = this.candidateAttendaceForm.get('trainer').value
        const firstAnswer = this.candidateAttendaceForm.get('feedbacks')['controls'][0].get('feedback').get('choice').value
        if (this.qualityRatingForm.status === 'INVALID') {
          if (firstAnswer) {
            toastr.error('Q3 is required');
            return;
          }
        }
        if (this.candidateAttendaceForm.get('feedbacks')['controls'][3].get('feedback').get('choice').value) {
          if (other === false && qOA === false && qoC === false && Qot === false && SFP === false && efT === false && tr == false) {
            toastr.error('Q7 is required');
            return;
          }
        }

        if (this.isUpdate) {
          swal({
            title: 'Are You Sure, You want to Update?',
            type: 'info',
            showCancelButton: true,
            cancelButtonText: 'Cancel',
            cancelButtonColor: '#d33',
          }).then((action: any) => {
            if (action.value) {
              this.utilityService.updateFeedback(this.batchDetails.batchId,this.loggedInUserName,'CPAC',this.mapPayload()).subscribe(res => {
                swal('Feedback Successfully Updated');
                this.goBack();
              })
            }
          })
        } else {
          swal({
            title: 'Are You Sure, You want to submit?',
            type: 'info',
            showCancelButton: true,
            cancelButtonText: 'Cancel',
            cancelButtonColor: '#d33',
          }).then((action: any) => {
            if (action.value) {
              this.utilityService.addFeedback(this.mapPayload()).subscribe(res => {
                swal('Feedback Successfully Submitted');
                this.goBack();
              })
            }
          })
        }
      } else {
        toastr.error("Please Submit Candidate's Enrollment Form Before Proceeding To Assessment Form ");
        return;
      }
    })



  }

  goBack() {
    this.location.back()

  }

  validate(i) {
    this.candidateAttendaceForm.get('feedbacks')['controls'][2].get('feedback').get('choice').setValidators([])
    this.candidateAttendaceForm.get('feedbacks')['controls'][2].get('feedback').get('choice').updateValueAndValidity()
    this.candidateAttendaceForm.get('feedbacks')['controls'][6].get('feedback').get('choice').setValidators([])
    this.candidateAttendaceForm.get('feedbacks')['controls'][6].get('feedback').get('choice').updateValueAndValidity()
    const userChoice = this.candidateAttendaceForm.get('feedbacks')['controls'][i].value.feedback.choice
    if (userChoice === "1" || userChoice === "2" || userChoice === '3') {
      for (let index = 0; index < this.questions.length; index++) {
        if (this.questions[index].id === 'Q7') {
          this.questions[index].questionString = this.specialQuestion[0]
      }
      }
    } else if (userChoice === "4" || userChoice === "5") {
      for (let index = 0; index < this.questions.length; index++) {
        if (this.questions[index].id === 'Q7') {
          this.questions[index].questionString = this.specialQuestion[1]
        }
      }
    }
  }

  isBelowRequired(i) {

    this.candidateAttendaceForm.get('feedbacks')['controls'][2].get('feedback').get('choice').setValidators([])
    this.candidateAttendaceForm.get('feedbacks')['controls'][2].get('feedback').get('choice').updateValueAndValidity()
    this.candidateAttendaceForm.get('feedbacks')['controls'][6].get('feedback').get('choice').setValidators([])
    this.candidateAttendaceForm.get('feedbacks')['controls'][6].get('feedback').get('choice').updateValueAndValidity()
    const userChoice = this.candidateAttendaceForm.get('feedbacks')['controls'][i].value.feedback
    if (userChoice && userChoice.id === 'Q1') {
      if (userChoice && userChoice.choice === false) {
        this.candidateAttendaceForm.get('others').disable(),
        this.candidateAttendaceForm.get('qualityOfAssessment').disable(),
        this.candidateAttendaceForm.get('qualityOfCourseMaterials').disable(),
         this.candidateAttendaceForm.get('qualityOfTrainingDelivery').disable(),
        this.candidateAttendaceForm.get('supportFromTPonPlacement').disable(),
       this.candidateAttendaceForm.get('equipmentForTraining').disable(),
       this.candidateAttendaceForm.get('trainer').disable(),
          this.candidateAttendaceForm.get('otherAnswer').disable()

          this.candidateAttendaceForm.get('others').reset(),
          this.candidateAttendaceForm.get('qualityOfAssessment').reset(),
          this.candidateAttendaceForm.get('qualityOfCourseMaterials').reset(),
           this.candidateAttendaceForm.get('qualityOfTrainingDelivery').reset(),
          this.candidateAttendaceForm.get('supportFromTPonPlacement').reset(),
         this.candidateAttendaceForm.get('equipmentForTraining').reset(),
         this.candidateAttendaceForm.get('trainer').reset(),
          this.candidateAttendaceForm.get('otherAnswer').reset()
        for (let index = 1; index < this.candidateAttendaceForm.get('feedbacks')['controls'].length; index++) {
          this.candidateAttendaceForm.get('feedbacks')['controls'][index].get('feedback').get('choice').disable()
          this.candidateAttendaceForm.get('feedbacks')['controls'][index].get('feedback').get('choice').reset()
          this.candidateAttendaceForm.get('feedbacks')['controls'][index].get('feedback').get('choice').setValidators([])
          this.candidateAttendaceForm.get('feedbacks')['controls'][index].get('feedback').get('choice').updateValueAndValidity()
        }

        for (let indexx = 0; indexx < this.qualityRatingForm.get('rating')['controls'].length; indexx++) {
          this.qualityRatingForm.get('rating')['controls'][indexx].get('ratingArray').get('choice').disable()
          this.qualityRatingForm.get('rating')['controls'][indexx].get('ratingArray').get('choice').reset()
          this.qualityRatingForm.get('rating')['controls'][indexx].get('ratingArray').get('choice').setValidators([])
          this.qualityRatingForm.get('rating')['controls'][indexx].get('ratingArray').get('choice').updateValueAndValidity()
        }
      }
      else {
        this.candidateAttendaceForm.get('others').enable(),
        this.candidateAttendaceForm.get('qualityOfAssessment').enable(),
        this.candidateAttendaceForm.get('qualityOfCourseMaterials').enable(),
         this.candidateAttendaceForm.get('qualityOfTrainingDelivery').enable(),
        this.candidateAttendaceForm.get('supportFromTPonPlacement').enable(),
       this.candidateAttendaceForm.get('equipmentForTraining').enable(),
       this.candidateAttendaceForm.get('trainer').enable(),
        this.candidateAttendaceForm.get('otherAnswer').enable()
        for (let index = 1; index < this.candidateAttendaceForm.get('feedbacks')['controls'].length; index++) {
          this.candidateAttendaceForm.get('feedbacks')['controls'][index].get('feedback').get('choice').enable()
          this.candidateAttendaceForm.get('feedbacks')['controls'][index].get('feedback').get('choice').setValidators([Validators.required])
          this.candidateAttendaceForm.get('feedbacks')['controls'][index].get('feedback').get('choice').updateValueAndValidity()
        }
        for (let indexx = 0; indexx < this.qualityRatingForm.get('rating')['controls'].length; indexx++) {
          this.qualityRatingForm.get('rating')['controls'][indexx].get('ratingArray').get('choice').enable()
          this.qualityRatingForm.get('rating')['controls'][indexx].get('ratingArray').get('choice').setValidators([Validators.required])
          this.qualityRatingForm.get('rating')['controls'][indexx].get('ratingArray').get('choice').updateValueAndValidity()
        }
      }

    } else if (userChoice && userChoice.id === 'Q4') {
      if (userChoice && userChoice.choice === false) {
        //  for (let index = 1; index < this.candidateAttendaceForm.get('feedbacks')['controls'].length; index++) {
        this.candidateAttendaceForm.get('feedbacks')['controls'][4].get('feedback').get('choice').disable()
        this.candidateAttendaceForm.get('feedbacks')['controls'][4].get('feedback').get('choice').reset()
        this.candidateAttendaceForm.get('feedbacks')['controls'][4].get('feedback').get('choice').setValidators([])
        this.candidateAttendaceForm.get('feedbacks')['controls'][4].get('feedback').get('choice').updateValueAndValidity()
        this.candidateAttendaceForm.get('feedbacks')['controls'][5].get('feedback').get('choice').disable()
        this.candidateAttendaceForm.get('feedbacks')['controls'][5].get('feedback').get('choice').reset()
        this.candidateAttendaceForm.get('feedbacks')['controls'][5].get('feedback').get('choice').setValidators([])
        this.candidateAttendaceForm.get('feedbacks')['controls'][5].get('feedback').get('choice').updateValueAndValidity()

        this.candidateAttendaceForm.get('feedbacks')['controls'][6].get('feedback').get('choice').disable()
        this.candidateAttendaceForm.get('feedbacks')['controls'][6].get('feedback').get('choice').reset()
        this.candidateAttendaceForm.get('feedbacks')['controls'][6].get('feedback').get('choice').setValidators([])
        this.candidateAttendaceForm.get('feedbacks')['controls'][6].get('feedback').get('choice').updateValueAndValidity()
        this.candidateAttendaceForm.get('others').disable(),
        this.candidateAttendaceForm.get('qualityOfAssessment').disable(),
        this.candidateAttendaceForm.get('qualityOfCourseMaterials').disable(),
         this.candidateAttendaceForm.get('qualityOfTrainingDelivery').disable(),
        this.candidateAttendaceForm.get('supportFromTPonPlacement').disable(),
       this.candidateAttendaceForm.get('equipmentForTraining').disable(),
       this.candidateAttendaceForm.get('trainer').disable(),
          this.candidateAttendaceForm.get('otherAnswer').disable()
      } else {
        this.candidateAttendaceForm.get('feedbacks')['controls'][4].get('feedback').get('choice').enable()
        this.candidateAttendaceForm.get('feedbacks')['controls'][4].get('feedback').get('choice').reset()
        this.candidateAttendaceForm.get('feedbacks')['controls'][4].get('feedback').get('choice').setValidators([Validators.required])
        this.candidateAttendaceForm.get('feedbacks')['controls'][4].get('feedback').get('choice').updateValueAndValidity()

        this.candidateAttendaceForm.get('feedbacks')['controls'][5].get('feedback').get('choice').enable()
        this.candidateAttendaceForm.get('feedbacks')['controls'][5].get('feedback').get('choice').reset()
        this.candidateAttendaceForm.get('feedbacks')['controls'][5].get('feedback').get('choice').setValidators([Validators.required])
        this.candidateAttendaceForm.get('feedbacks')['controls'][5].get('feedback').get('choice').updateValueAndValidity()

        this.candidateAttendaceForm.get('feedbacks')['controls'][6].get('feedback').get('choice').enable()
        this.candidateAttendaceForm.get('feedbacks')['controls'][6].get('feedback').get('choice').reset()
        this.candidateAttendaceForm.get('feedbacks')['controls'][6].get('feedback').get('choice').setValidators([Validators.required])
        this.candidateAttendaceForm.get('feedbacks')['controls'][6].get('feedback').get('choice').updateValueAndValidity()

        this.candidateAttendaceForm.get('others').enable(),
        this.candidateAttendaceForm.get('qualityOfAssessment').enable(),
        this.candidateAttendaceForm.get('qualityOfCourseMaterials').enable(),
         this.candidateAttendaceForm.get('qualityOfTrainingDelivery').enable(),
        this.candidateAttendaceForm.get('supportFromTPonPlacement').enable(),
       this.candidateAttendaceForm.get('equipmentForTraining').enable(),
       this.candidateAttendaceForm.get('trainer').enable(),
          this.candidateAttendaceForm.get('otherAnswer').enable()
      }
    }
  }

  reset() {
    this.candidateAttendaceForm.reset();
    this.candidateAttendaceForm.enable();
    for (let index = 0;index <this.qualityRatingForm.get('rating')['controls'].length; index++) {
      this.qualityRatingForm.get('rating')['controls'][index].get('ratingArray').get('choice').reset();
      this.qualityRatingForm.get('rating')['controls'][index].get('ratingArray').get('choice').enable();


    }

  }
}
